import { LAMINATE_REGEX, WOOD_REGEX } from '@common/constants/MaterialType-Constants';

export enum AreaCalculationType {
    Manufactured,
    Raw,
}

/**
 * various material-specific application options that should _REALLY_ come from the database but don't
 * @param matcher a string or regex to match against the material name
 * @param areaType use Manufactured (DEFAULT) or Raw area calculation
 * @param jointPointMaxLength the max length of a segment of the shape before we add joint points
 */
export interface MaterialOptions {
    nameMatcher: RegExp | string;
    areaType?: AreaCalculationType;
    jointPointMaxLength?: number;
}

/*
Materials matching any of these regexp will use the rawMaterialArea calculations
 - wood
 - any laminate products
 */
export const MATERIAL_OPTIONS: MaterialOptions[] = [
    { nameMatcher: WOOD_REGEX, areaType: AreaCalculationType.Raw, jointPointMaxLength: 97 },
    { nameMatcher: LAMINATE_REGEX, areaType: AreaCalculationType.Raw, jointPointMaxLength: 97 },
];
